import React, { useContext } from 'react'
import { EasybakeContext } from './EasybakeProvider'
import Label from '@react/react-spectrum/Label'

export default function DebugStatus ({ page }) {
    const { ut } = useContext(EasybakeContext)
    function getLoginStatus () {
        return ut ? <Label variant="green">DEBUG VERSION - Signed In</Label> : <Label variant="red">DEBUG VERSION - Not Signed In</Label>
    }
    return <div className="adobe-easybake-test-label">
        { getLoginStatus() }
    </div>
}
